$("#product-carousel-section-v2").ready(async function () {
  await ResourceCoordinator.requestVendor("Splide");

  this.querySelector(".ssr-skeleton").remove();

  new Splide("#product-carousel-section-v2 .splide", {
    gap: "8px",
    padding: "16px",
    mediaQuery: "min",
    arrows: false,
    perPage: 1,
    fixedWidth: "304px",
    breakpoints: {
      768: {
        perPage: 2,
        gap: "16px",
        padding: "32px",
        fixedWidth: "344px",
      },
      1024: {
        perPage: 4,
        gap: "20px",
        arrows: true,
        fixedWidth: undefined,
      },
      1280: {
        perPage: 4,
        gap: "32px",
        padding: "64px",
        arrows: true,
      },
    },
  }).mount();
});
